import { combineReducers } from 'redux';
import list from './employees_list_reducers';
import form from './employees_form_reducers';

export const custom_fields_employeesReducers = combineReducers({ list, form });



// WEBPACK FOOTER //
// src/modules/secured/modules/custom_fields_employees/reducers/index.js